import { render, staticRenderFns } from "./MediaPlayer.vue?vue&type=template&id=3c044394&"
import script from "./MediaPlayer.vue?vue&type=script&lang=js&"
export * from "./MediaPlayer.vue?vue&type=script&lang=js&"
import style0 from "./MediaPlayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports